<div class="center-wrapper app-order" (click)=openBox()>
	<div class="pedido-paso3">
		<div class="tag-app black">
			<i class="material-icons">lock</i>
		</div>
	    <div>
	        <div class="main-box">
	            <div class="number-box">
	                <div class="box-container">
	                    <span class="number-container">7</span>
	                </div>
	            </div>
	            <p class="nombre-cliente truncate">Diego Lopez</p>
	            <!-- <p class="nombre-cliente truncate">Nombre</p> -->
	            <div class="pedido">
	                Wok de Pollo, Lemon Rush
	            </div>
	        </div>
	        <div class="text-center btn-wrapper">
	            <a class="btn btn-lg btn-touch">Abrir Box desde App</a>
	            <div class="time-remaining">
	            	Te quedan 
	            	<div>
		            	<span class="digital-watch">10</span>
		            	<span class="digital-watch">50</span>
	            	</div>
	            	para retirar tu pedido
            	</div>
	        </div>
	    </div>
	</div>
</div>